import React, { useRef } from 'react';
import { apiGetOrganizationParagonToken } from './journeyApi';
import loadParagon from './integration/paragon';
import { OrganizationUser } from 'src/common/interfaces/organization/user.interface';
import { Organization } from 'src/common/interfaces/organization.interface';

export const useParagon = (currentUser: OrganizationUser, currentOrganization: Organization) => {
  const paragonTokenRef = useRef<string | null>(null);
  const initialize = () =>
    new Promise<string[]>((resolve) => {
      apiGetOrganizationParagonToken().then((response) => {
        paragonTokenRef.current = response.paragon_token;
        if (response.paragon_token) {
          loadParagon(response.paragon_token, currentUser, currentOrganization).then(() => {
            if (window.paragon) {
              const paragonUser = window.paragon.getUser();
              if (paragonUser.authenticated) {
                const integrations = Object.entries(paragonUser.integrations)
                  .filter(([_, details]: any) => !!details.enabled)
                  .map(([apiName]) => apiName);
                resolve(integrations);
              }
            }
          });
        }
      });
    });

  const getActiveIntegrations = () => {
    if (window.paragon) {
      const paragonUser = window.paragon.getUser();
      return Object.entries(paragonUser.integrations)
        .filter(([_, details]: any) => !!details.enabled)
        .map(([apiName]) => apiName);
    }
    return [];
  };

  const isIntegrationActive = (name: string) => {
    if (window.paragon) {
      const paragonUser = window.paragon.getUser();
      return paragonUser.integrations[name]?.enabled;
    }
    return false;
  };

  const authenticate = () => {
    return window.paragon!.authenticate(process.env.PARAGON_ID, paragonTokenRef.current);
  };

  return { initialize, authenticate, getActiveIntegrations, isIntegrationActive };
};
